import { render, staticRenderFns } from "./createWeChatDetails.vue?vue&type=template&id=78461590&scoped=true&"
import script from "./createWeChatDetails.vue?vue&type=script&lang=js&"
export * from "./createWeChatDetails.vue?vue&type=script&lang=js&"
import style0 from "./createWeChatDetails.vue?vue&type=style&index=0&id=78461590&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78461590",
  null
  
)

export default component.exports